/**
 * Do not edit directly
 */

export default "PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PHRpdGxlPkZsb3cgRmlsZTwvdGl0bGU+PHBhdGggZD0iTTE0LjUsOS41MXYtNGgtNFY3SDVWNC41SDYuNVYuNWgtNHY0SDRWMTRIMTAuNVYxNS41aDR2LTRoLTRWMTNINVY4SDEwLjV2MS41Wm0tMTEtOGgydjJoLTJabTgsMTFoMnYyaC0yWm0wLTZoMnYyaC0yWiIvPjwvc3ZnPg==";